export function resolveMediaUrl(url) {
  if (!url) return '';
  if (typeof url !== 'string') url = String(url);
  // data URIs pass through
  if (url.startsWith('data:')) return url;

  // Vor-Normalisierung: Mehrfaches /api vor Medien-Pfaden reduzieren (z.B. /api/api/avatars/ -> /api/avatars/)
  // Nur anwenden, wenn es wirklich doppelt vorkommt.
  if (/^(?:\/api){2,}\/(avatars|uploads|social-content)\//i.test(url)) {
    url = url.replace(/^(?:\/api)+\/(?=(avatars|uploads|social-content)\/)/i, '/api/');
  }

  // If absolute HTTP/HTTPS URL, optionally normalize to configured/same-origin base
  if (/^https?:\/\//i.test(url)) {
    try {
      const u = new URL(url);
      // Auch bei absoluten URLs doppelte /api Segmente im Pfad eliminieren
      if (/^(?:\/api){2,}\/(avatars|uploads|social-content)\//i.test(u.pathname)) {
        u.pathname = u.pathname.replace(/^(?:\/api)+\/(?=(avatars|uploads|social-content)\/)/i, '/api/');
      }
      const path = u.pathname + (u.search || '') + (u.hash || '');
      const _apiBase = (import.meta.env.VITE_API_URL || '').trim();
      const _mediaCfg = (import.meta.env.VITE_MEDIA_BASE || '').trim();
      const preferBase = (_mediaCfg || _apiBase.replace(/\/api\/?$/, ''))?.replace?.(/\/$/, '') || '';
      const isKnownMediaPath = /\/(avatars|uploads|social-content)\//i.test(u.pathname);

      // If we have a preferred base and the URL points to a known media path (or is localhost), rewrite to preferred base
      if (preferBase && (isKnownMediaPath || /(^|\.)localhost$/i.test(u.hostname) || /^127\./.test(u.hostname) || /^0\.0\.0\.0$/.test(u.hostname))) {
        return preferBase + path;
      }

      // If current page is HTTPS and the URL is HTTP to same host, upgrade scheme
      try {
        if (typeof window !== 'undefined' && window.location && window.location.protocol === 'https:' && u.protocol === 'http:' && u.hostname === window.location.hostname) {
          u.protocol = 'https:';
          return u.toString();
        }
      } catch {}

      // Otherwise, keep as-is
      return url;
    } catch {
      return url;
    }
  }

  // Prefer explicit media base or API URL when provided
  const _apiBase = (import.meta.env.VITE_API_URL || '').trim();
  const _mediaCfg = (import.meta.env.VITE_MEDIA_BASE || '').trim();
  const envBase = (_mediaCfg || _apiBase.replace(/\/api\/?$/, '')) || '';
  // Only prefix envBase for known media paths; otherwise keep same-origin (frontend public assets etc.)
  const isKnownMediaPath = /^\/(avatars|uploads|social-content)\//i.test(url);
  if (envBase && isKnownMediaPath) {
    const baseNoSlash = String(envBase).replace(/\/$/, '');
    return url.startsWith('/') ? (baseNoSlash + url) : `${baseNoSlash}/${url}`;
  }

  // No env base configured
  if (import.meta.env && import.meta.env.DEV) {
    // Dev fallback: typical backend dev port
    const devBase = 'http://localhost:5000';
    const baseNoSlash = devBase.replace(/\/$/, '');
    return url.startsWith('/') ? (baseNoSlash + url) : `${baseNoSlash}/${url}`;
  }

  // In production, prefer same origin (behind reverse proxy)
  try {
    const origin = (typeof window !== 'undefined' && window.location && window.location.origin) ? String(window.location.origin) : '';
    if (origin) {
      const o = origin.replace(/\/$/, '');
      return url.startsWith('/') ? (o + url) : `${o}/${url}`;
    }
  } catch {}

  // Final fallback: return as-is
  return url;
}
